import React from 'react';

import * as styles from './styles.module.scss';

const styling = {
    borderRadius: 100,
    width: 97,
    height: 97,
    margin: '0 auto 15px',
    objectFit: 'cover',
    display: 'block',
} as any;

type Props = {
    name: string;
    job_title: string;
    description: string;
    image: string;
    isAmp?: boolean;
};

const BorderCard: React.FunctionComponent<Props> = ({ name, job_title, description, image, isAmp = false }) => {
    const imageComp = () => {
        if (!image) return null;
        if (isAmp) return <img src={image} alt={name} style={styling} />;
        return <img src={image} alt={name} style={styling} loading="lazy" />;
    };
    return (
        <div className={styles['border_card']}>
            {imageComp()}
            <span>{name}</span>
            <span>{job_title}</span>
            <p>{description}</p>
        </div>
    );
};

export default BorderCard;
